// based on https://gist.github.com/thomseddon/3511330
export function bytes(bytes, precision = 1) {
  if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-'
  if (bytes === 0) { return '0 bytes' }
  let units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB']
  let number = Math.floor(Math.log(bytes) / Math.log(1000))
  return (bytes / Math.pow(1000, Math.floor(number))).toFixed(precision) +  ' ' + units[number]
}
